import React from 'react';
import { Text } from '@input';
import { keys } from '@enums';
import { upperFirst, isNumber } from 'lodash';
import { formatCurrency, isPurchase } from '@helpers';

function HomeValue({ loanPurpose, ...props }) {
  const text = isPurchase(loanPurpose) ? 'Purchase Price' : 'Home Value';

  return (
    <Text
      label={text}
      className="input-home-value"
      fieldClassName="field-home-value"
      name={keys.HOME_VALUE}
      maxWidth={140}
      isCurrency
      {...props}
    />
  );
}

function validate(num, state, validations) {
  const label = isPurchase(state.loanPurpose) ? 'purchase price' : 'home value';

  num = parseFloat(num);

  if (isNaN(num)) {
    return `Enter a valid ${label}`;
  }

  const { minHomeValue = 0, maxHomeValue = 0 } = validations;
  const hasMinHomeValue = isNumber(minHomeValue) && minHomeValue > 0;
  const hasMaxHomeValue =
    isNumber(maxHomeValue) &&
    (hasMinHomeValue ? maxHomeValue > minHomeValue : maxHomeValue > 0);

  if (hasMinHomeValue || hasMaxHomeValue) {
    if (hasMinHomeValue && num < minHomeValue) {
      return hasMaxHomeValue
        ? `Enter a ${label} between ${formatCurrency(
          minHomeValue
        )} and ${formatCurrency(maxHomeValue)}`
        : `Enter a ${label} of at least ${formatCurrency(minHomeValue)}`;
    } else if (hasMaxHomeValue && num > maxHomeValue) {
      return hasMinHomeValue
        ? `Enter a ${label} between ${formatCurrency(
          minHomeValue
        )} and ${formatCurrency(maxHomeValue)}`
        : `Enter a ${label} of ${formatCurrency(maxHomeValue)} or less`;
    }
  }

  if (!hasMinHomeValue && num <= 0) {
    return `Enter a ${label} of at least $0`;
  }

  if (num < parseFloat(state[keys.LOAN_AMOUNT])) {
    return `${upperFirst(label)} must be greater than loan amount`;
  }
}

export default {
  Component: HomeValue,
  dependencies: keys.LOAN_PURPOSE,
  validate: {
    fn: validate,
    dependencies: [keys.LOAN_AMOUNT, keys.CASH_OUT_AMOUNT]
  }
};
